/**
 * aswbe checkin eapi
 * チェックイン業務で利用するAPIを提供する
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { PostJourneysGetJourneyResponseDataFlightsInnerArrival } from './postJourneysGetJourneyResponseDataFlightsInnerArrival';
import { PostJourneysGetJourneyResponseDataFlightsInnerOperationStatus } from './postJourneysGetJourneyResponseDataFlightsInnerOperationStatus';
import { PostJourneysGetJourneyResponseDataFlightsInnerDeparture } from './postJourneysGetJourneyResponseDataFlightsInnerDeparture';

export interface PostJourneysGetJourneyResponseDataFlightsInner {
  /**
   * セグメントのID（アップグレード空席待ちセグメントの場合、末尾に\"-UPG\"を付与する）
   */
  id: string;
  departure: PostJourneysGetJourneyResponseDataFlightsInnerDeparture;
  arrival: PostJourneysGetJourneyResponseDataFlightsInnerArrival;
  /**
   * 国内際区分<br> DOM:日本国内線<br> INT:国際線
   */
  routeType: PostJourneysGetJourneyResponseDataFlightsInner.RouteTypeEnum;
  /**
   * 深夜発かどうか<br> 出発時刻が設定ファイルに定義した深夜発時間帯の間であればtrue
   */
  isLateNightDeparture: boolean;
  /**
   * 当該セグメントの発着日時から導出した、出発日と到着日の年月日単位の日数差
   */
  arrivalDaysDifferenceByFlight: number;
  /**
   * 当該セグメントの最新発着日時から導出した、出発日と到着日の年月日単位の日数差
   */
  arrivalDaysDifferenceByFlightAfterScheduleChange?: number;
  /**
   * 販売キャリアコード（IATA 2レターコード）
   */
  marketingAirlineCode: string;
  /**
   * 販売便番号
   */
  marketingFlightNumber?: string;
  /**
   * 運航キャリアコード（IATA 2レターコード）
   */
  operatingAirlineCode?: string;
  /**
   * DxAPIから返却された運航キャリア名
   */
  operatingAirlineName?: string;
  /**
   * 運航便番号
   */
  operatingFlightNumber?: string;
  /**
   * 便種別<br> nhGroupOperating:NHグループ運航便。販売キャリアを問わず、NHグループ運航便である<br> nhGroupMarketing:NHグループ販売便。NHグループ販売便、かつ他社運航便である<br> otherAirlineMarketing:他社販売便。他社販売便、かつ他社運航便である
   */
  operatingType: PostJourneysGetJourneyResponseDataFlightsInner.OperatingTypeEnum;
  /**
   * 機種コード（IATAコード）
   */
  aircraftCode?: string;
  /**
   * 小型機である<br> 設定ファイルに定義した小型機の機種コードである場合にtrue
   */
  isSmallAircraft: boolean;
  /**
   * ACVコード
   */
  aircraftConfigurationVersion?: string;
  /**
   * 機材変更あり<br> 発着APIから取得した機材変更フラグが\"1\"の場合にtrue
   */
  isAircraftChanged?: boolean;
  /**
   * 発着APIから取得した変更後ゲート（ゲート変更時のみ）
   */
  changedGate?: string;
  /**
   * セグメントステータス
   */
  status: string;
  /**
   * 受付ステータス
   */
  acceptanceStatus: string;
  operationStatus: PostJourneysGetJourneyResponseDataFlightsInnerOperationStatus;
  /**
   * 空席利用ステータス<br> 設定ファイルに定義した空席利用のセグメントステータスの場合にtrue
   */
  isSpaceAvailableStatus: boolean;
  /**
   * 空席待ちステータス<br> 設定ファイルに定義した空席待ちのセグメントステータスの場合にtrue
   */
  isWaitlistedStatus: boolean;
  /**
   * DynamicWaiver適用あり<br> セグメントが以下の条件すべてに合致した場合にtrue  |No|条件| |---:|:---| |1|DynamicWaiverが適用されている| |2|未チェックインである| |3|以下のPNRに該当しない<br>1. 国内代理店作成PNR<br> オフィスコードの4～6桁目 = \"NH3\"である<br>2. GDS PNR<br>  オフィスコードの4～5桁目 ≠ “NH”である<br>3. グループPNR<br>  グループ予約フラグ = trueである<br>4. 社員用（DUTY・SUBLO）PNR<br>  搭乗者の社員種別 = \"bookable\"または\"standby\"である|
   */
  isDynamicWaiverApplied: boolean;
  /**
   * DynamicWaiver適用種別<br> DynamicWaiver適用ありがtrueの場合のみ返却する<br> change:DynamicWaiverChangeのみ適用あり<br> refund:DynamicWaiverRefundのみ適用あり<br> both:DynamicWaiverChangeとDynamicWaiverRefundの両方の適用あり
   */
  dynamicWaiverType?: PostJourneysGetJourneyResponseDataFlightsInner.DynamicWaiverTypeEnum;
  /**
   * 座席変更操作が可能である<br> セグメントが以下の条件のいずれかに合致した場合にtrue  |No|条件| |---:|:---| |1|1便目かつこのセグメントに紐づく受付ステータスがopenedである| |2|2便目以降かつこのセグメントに紐づく受付ステータスがopenedである、または直前の便が未出発である|
   */
  isSeatChangeEligible: boolean;
  /**
   * PNRのFare Familyをもとに取得したFF Priority Code<br>当該セグメントに対して異なるキャビンクラスのjourneyElementが混在する場合、返却しない
   */
  priorityCode?: string;
  /**
   * PNRから取得した食事の種類のコード<br>当該セグメントに対してキャビンクラスがファーストクラスであるjourneyElementが存在する場合、返却する
   */
  mealCode?: string;
  /**
   * UN/TKの場合のUN便である<br> trueの場合のみ返却する
   */
  isUnFlightInCaseOfUnTk?: boolean;
  /**
   * IATCI判定ステータス<br> IATCIである場合にtrue
   */
  isIATCI?: boolean;
}
export namespace PostJourneysGetJourneyResponseDataFlightsInner {
  export type RouteTypeEnum = 'DOM' | 'INT';
  export const RouteTypeEnum = {
    Dom: 'DOM' as RouteTypeEnum,
    Int: 'INT' as RouteTypeEnum,
  };
  export type OperatingTypeEnum = 'nhGroupOperating' | 'nhGroupMarketing' | 'otherAirlineMarketing';
  export const OperatingTypeEnum = {
    NhGroupOperating: 'nhGroupOperating' as OperatingTypeEnum,
    NhGroupMarketing: 'nhGroupMarketing' as OperatingTypeEnum,
    OtherAirlineMarketing: 'otherAirlineMarketing' as OperatingTypeEnum,
  };
  export type DynamicWaiverTypeEnum = 'change' | 'refund' | 'both';
  export const DynamicWaiverTypeEnum = {
    Change: 'change' as DynamicWaiverTypeEnum,
    Refund: 'refund' as DynamicWaiverTypeEnum,
    Both: 'both' as DynamicWaiverTypeEnum,
  };
}
